module.exports = new __parcel__URL__("view-front.9d20c051.png").toString();